import React from "react";
import {withTranslation} from "react-i18next";
import {compose} from "redux";
import {connect} from "react-redux";
import {Dimensions, StyleSheet, Text, TouchableOpacity, View, ScrollView} from "react-native";

function getStyle() {
  return StyleSheet.create({
    container: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      // marginTop: "6px",
      // justifyContent: "flex-start"
      // marginRight: "5px"
    },
    arrow: {
      paddingHorizontal: "5px"
    },
    // arrowSvg: { width: "25px", height: "18px" },
    pos: {
      color: "white",
      borderRadius: "5px",
      paddingVertical: "2px",
      paddingHorizontal: "5px",
      fontSize: "12px",
      fontWeight: 500
    }
  })
}

const positions = {
  committed: {
    fillColor: "rgba(72,119,205,1)",
    title: "committed"
  },
  supportive: {
    fillColor: "rgba(1,184,250,1)",
    title: "supportive"
  },
  hesitant: {
    fillColor: "rgba(8,191,91,1)",
    title: "hesitant"
  },
  neutral: {
    fillColor: "rgba(255,229,110,1)",
    title: "neutral"
  },
  passive: {
    fillColor: "rgba(8,191,91,1)",
    title: "passive"
  },
  opponent: {
    fillColor: "rgba(255,167,8,1)",
    title: "opponent"
  },
  contrarian: {
    fillColor: "rgba(255,167,8,1)",
    title: "contrarian"
  },
  adversary: {
    fillColor: "rgba(255,4,4,1)",
    title: "adversary"
  }
}

const svg = <svg style={{filter: "drop-shadow(0px 2px 2px rgba(0, 0, 0, 1))"}} width="25" height="18" viewBox="0 0 35 30">
  <defs>
    <marker id='head' orient="auto" markerWidth='3' markerHeight='3' refX='0.1' refY='1.5'>
      <path d='M0,0 V3 L1.5,1.5 Z' fill="yellow" />
    </marker>
  </defs>

  <path
    id='arrow-line'
    markerEnd='url(#head)'
    strokeWidth='10'
    fill='none' stroke='yellow'  
    d='M0,15 20 15,0 Z'
  />
</svg>


const Positions = ({t, node, editing, toggleEndPosition, small}) => {
  // check editing
  const start_pos = node.start_position === null ? null : positions[node.start_position];
  const end_pos = node.end_position === null ? null : positions[node.end_position];

  const styles = getStyle();

  // todo: make a small style
  return <View style={styles.container}>
    {start_pos && <Text style={[styles.pos, {backgroundColor: start_pos.fillColor}]}>
      { t(start_pos.title) }
    </Text>}
    {end_pos && <View style={styles.arrow}>{ svg }</View>}
    {end_pos && <Text style={[styles.pos, {backgroundColor: end_pos.fillColor}]}>
      { t(end_pos.title) }
    </Text>}
  </View>
}


const mapStateToProps = (state) => {
  return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default compose(withTranslation(),connect(mapStateToProps))(Positions);
